import { render, staticRenderFns } from "./printPayFeeBangTaiList.vue?vue&type=template&id=237cc0af&scoped=true"
import script from "./printPayFeeBangTaiList.vue?vue&type=script&lang=js"
export * from "./printPayFeeBangTaiList.vue?vue&type=script&lang=js"
import style0 from "./printPayFeeBangTaiList.vue?vue&type=style&index=0&id=237cc0af&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "237cc0af",
  null
  
)

export default component.exports